var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HomeLayout',{attrs:{"footer":false,"navbar":!_vm.isMD(true)}},[_c('RouterView',{staticStyle:{"margin-bottom":"56px"}}),_c('BottomNavigation',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMD(true)),expression:"isMD(true)"}]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }